import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import Contact from "../components/contact";
import Hero from "../commercial/components/hero";
import TriCards from "../commercial/components/triCards";
import PageShell from "../components/pageShell";
import ZigZag from "../commercial/components/zigzag";
import BeforeAfter from "../commercial/components/beforeAfter";
import { ButtonGroup } from "../components/basicUIComponents";
import { MetaTagHandler } from "../../../library/client/serverCallHandler";

const GutterCleaningPage = () => {

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Gutter Cleaning - Flyby Shine</title>
                        <meta name="description" content="Elevate Your Home and Property's Appeal with our Premium Gutter Cleaning Service." />
                        <meta name="keywords" content="Gutter Cleaning, Gutter cleaning services, residential gutter cleaning, home gutter cleaning, hygienic gutter cleaning, expert gutter cleaning services, safe gutter cleaning, thorough gutter cleaning, professional gutter cleaning, reliable gutter cleaning, top-quality gutter cleaning, gutter cleaning services, gutter cleaning solutions, gutter cleaning experts" />
                        <meta property="og:image" content="/assets/gutterAfter.png" />
                    </>
                )}
            </MetaTagHandler>
            <PageShell>
                <Hero
                    subTitle={'Residential & Home'}
                    title={'Gutter Cleaning'}
                    description={`Elevate Your Home and Property's Appeal with our Premium Gutter Cleaning Service.`}
                    banner={{
                        video: '/assets/videos/gutter.mp4',
                        thumbnail: '/assets/videos/thumbnails/gutter.png'
                    }}
                    callToAction={
                        <ButtonGroup>
                            <ButtonGroup.Button to={'https://fc.flybyshine.tech/request-work'} text={'Request an Estimate'} />
                            <ButtonGroup.Button to={'/residential-home'} text={'All Services'} />
                        </ButtonGroup>
                    }

                />
                <TriCards>
                    <TriCards.Card
                        title={'Experienced Team'}
                        heading={{ image: '/assets/checkmark.svg', alt: 'Check Mark' }}
                        description={'Our trained professionals have extensive experience in gutter cleaning and are committed to delivering reliable, high-quality service.'}

                    />
                    <TriCards.Card
                        title={'High-Quality Equipment'}
                        heading={{ image: '/assets/equipment.svg', alt: 'equipment icon' }}
                        description={'We utilize industrial-grade specialized equipment to remove all debris, and dirt, ensuring that your gutters remain clean and functional.'}
                    />
                    <TriCards.Card
                        title={'Preventative Maintenance'}
                        heading={{ image: '/assets/shieldIcon.svg', alt: 'about' }}
                        description={'Regular cleaning helps to prevent deterioration caused by dirt, chemicals, and weather. '}
                    />
                </TriCards>
                <BeforeAfter
                    title={"Before And After"}
                    description={"Wash away the dirt and grime from your gutter wit our acceptionaly trained team."}
                    subTitle={"Gutter Cleaning"}
                    additionalDetails={
                        <div className="core-list">
                            <ul>
                                <li><i className="material-icons">check_circle_outline</i>Efficient & Fast Cleaning</li>
                                <li><i className="material-icons">check_circle_outline</i>Accepetionally Clean</li>
                                <li><i className="material-icons">check_circle_outline</i>Industrial Grade Equipment</li>
                            </ul>
                        </div>
                    }
                    images={[{
                        firstImage: {
                            imageUrl: '/assets/gutterBefore.png',
                        },
                        secondImage: {

                            imageUrl: '/assets/gutterAfter.png',
                        }

                    }
                    ]}

                />

                <ZigZag>

                    <ZigZag.Card
                        largeGraphic={{
                            video: '/assets/videos/home.mp4',
                            thumbnail: '/assets/videos/thumbnails/home.png'

                        }}
                        title={'Prevent Home Damage'}
                        heading={{ image: '/assets/star.svg', alt: 'faster bolt icon' }}
                        description={'Over time, dirt, mold, and mildew can cause significant damage to your home’s exterior, leading to costly repairs. '}
                    />
                </ZigZag>
                <Contact />
            </PageShell>
            <style>
                {
                    `
                    .zigzag {
                    margin-top: 150px
                    }
                    `
                }
            </style>

        </>
    )
}

export default GutterCleaningPage
